// extracted by mini-css-extract-plugin
export default {"tempCreds":"tempCreds_tempCreds__LYqV0","select":"tempCreds_select__IoaEc"};